import { Box, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

const TileBox = ({ title, children, height = "100%" }) => {
  const classes = useStyles();
  return (
    <Box id={title} className={classes.root} height={height}>
      <Box className={classes.headerView}>
        {title && <Typography variant="subtitle1">{title}</Typography>}
      </Box>
      <Box px={4} py={3}>
        {children}
      </Box>
    </Box>
  );
};

export default TileBox;
